import React from 'react';
import messages from '../../messages';
import {useVariantForm} from './use-variant-form';
import Icon from '@ailibs/feather-react-ts/dist/Icon';
import AppBarActions from 'components/VerticalLayout/app-bar-actions';
import AsyncItemPicker from 'components/async-item-picker';
import Button from 'components/button';
import DateInput from 'components/date-input';
import TextInput from 'components/text-input';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router';
import {Alert, Col, Label, Row} from 'reactstrap';
import {selectProduct} from 'store/production/endpoints/show-product';
import {Product} from 'types/product';

const CreateVariant = () => {
  const navigate = useNavigate();

  const {id: productId} = useParams();

  const {submit, params, isLoading, validationErrors, errorMessage, setParams} =
    useVariantForm();

  const {t} = useTranslation();

  const parent = useSelector(selectProduct({id: productId})).data
    ?.data as Product;

  const hasComponentAsParent = parent.product_collection.type == 'COMPONENT';

  return (
    <div>
      <Row className="mb-3">
        {/* <Col md={12}>
          <AsyncItemPicker
            endPoint="data/product-variants-categories"
            label={t(...messages.category())}
            onChange={variant_category =>
              setParams({...params, variant_category})
            }
            value={params.variant_category}
            errors={validationErrors.product_variant_category_id}
          />
        </Col> */}
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <TextInput
            errors={validationErrors.name}
            label={t('updateGeneralTabPage.name')}
            onChange={name => setParams({...params, name})}
            value={params.name}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12} className="mb-0">
          <Label className="mb-0">{t(...messages.dimension())} </Label>
        </Col>

        <Col md={3}>
          <TextInput
            type="number"
            errors={validationErrors.height}
            onChange={height => setParams({...params, height})}
            value={params.height}
          />
        </Col>
        <Col md={3}>
          <TextInput
            errors={validationErrors.width}
            onChange={width => setParams({...params, width})}
            type="number"
            value={params.width}
          />
        </Col>
        <Col md={3}>
          <TextInput
            className="me-3"
            type="number"
            errors={validationErrors.depth}
            onChange={depth => setParams({...params, depth})}
            value={params.depth}
          />
        </Col>

        <Col md={3}>
          <TextInput
            type="number"
            pattern="^\d+$"
            min="0"
            errors={validationErrors.diameter}
            onChange={diameter => setParams({...params, diameter})}
            value={params.diameter}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <AsyncItemPicker
            endPoint="data/colors"
            label={t(...messages.color())}
            errors={validationErrors.color_id}
            onChange={colors => setParams({...params, colors})}
            isMulti
            value={params.colors}
          />
        </Col>
        <Col md={6}>
          <TextInput
            errors={validationErrors.finition}
            label={t(...messages.finition())}
            onChange={finition => setParams({...params, finition})}
            value={params.finition}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <AsyncItemPicker
            endPoint="data/matters"
            label={t(...messages.matter())}
            onChange={matters => setParams({...params, matters})}
            value={params.matters}
            isMulti
            errors={validationErrors.matter_id}
          />
        </Col>
        <Col md={6}>
          <AsyncItemPicker
            endPoint="data/ecotaxes"
            label={t(...messages.ecoTax())}
            value={params.ecotax}
            errors={validationErrors.eco_tax}
            onChange={ecotax => setParams({...params, ecotax})}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <TextInput
            rows={4}
            type="textarea"
            label={t(...messages.description())}
            value={params.description}
            errors={validationErrors.description}
            onChange={description => setParams({...params, description})}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <TextInput
            type="textarea"
            label={t(...messages.comment())}
            rows={4}
            value={params.comment}
            errors={validationErrors.comment}
            onChange={comment => setParams({...params, comment})}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <DateInput
            label={t(...messages.createdAt())}
            onChange={creation_date => setParams({...params, creation_date})}
            value={params.creation_date}
            errors={validationErrors.creation_date}
          />
        </Col>
        <Col md={4}>
          <TextInput
            label={t(...messages.stockMin())}
            onChange={stock_min => setParams({...params, stock_min})}
            value={params.stock_min}
            type="number"
            errors={validationErrors.stock_min}
          />
        </Col>
        <Col md={4}>
          <TextInput
            label={t(...messages.stockMax())}
            onChange={stock_max => setParams({...params, stock_max})}
            type="number"
            value={params.stock_max}
            errors={validationErrors.stock_max}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={3}>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              onChange={catalogue =>
                setParams({...params, catalogue: catalogue.target.checked})
              }
              checked={params.catalogue}
              id="catalogue"
            />
            <label className="form-check-label" htmlFor="catalogue">
              {t(...messages.catalog())}
            </label>
          </div>
        </Col>
        <Col md={3} className="d-flex justify-content-start">
          <div className="form-check ">
            <input
              className="form-check-input "
              type="checkbox"
              onChange={() =>
                setParams({...params, is_transferable: !params.is_transferable})
              }
              id="is_transferable"
              checked={params.is_transferable}
            />
            <label className="form-check-label " htmlFor="is_transferable">
              {t('updateGeneralTabPage.transferableProduct')}
            </label>
          </div>
        </Col>
        <Col md={3}>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              onChange={self_composed =>
                setParams({
                  ...params,
                  self_composed: self_composed.target.checked,
                })
              }
              disabled={hasComponentAsParent}
              checked={params.self_composed || hasComponentAsParent}
              id="self_composed"
            />
            <label className="form-check-label" htmlFor="self_composed">
              {t(...messages.selfComposed())}
            </label>
          </div>
        </Col>
        <Col md={3}>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              onChange={() =>
                setParams({
                  ...params,
                  is_published: !params.is_published,
                })
              }
              checked={params.is_published}
              id="is_published"
            />
            <label className="form-check-label" htmlFor="is_published">
              {t(...messages.published())}
            </label>
          </div>
        </Col>
        </Row>
        <Row className="mb-3">
        <Col md={3}>
          <div className="form-check ">
            <input
              className="form-check-input"
              type="checkbox"
              onChange={() =>
                setParams({
                  ...params,
                  is_limited_edition: !params.is_limited_edition,
                })
              }
              id="is_limited_edition"
              checked={params.is_limited_edition}
            />
            <label className="form-check-label" htmlFor="is_limited_edition">
              {t(...messages.limited())}
            </label>
          </div>
          <div className="mt-2">
            {!!params.is_limited_edition && (
              <TextInput
                label="Nombre de l'édition"
                type="number"
                onChange={x => setParams({...params, limited_edition_count: x})}
                value={params.limited_edition_count}
                errors={validationErrors.limited_edition_count}
              />
            )}
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={12} className=" mb-4">
          <AppBarActions>
            <Button isLoading={isLoading} onClick={submit} color="important">
              <Icon name="check" size={15} className="me-1" />
              {t('common.saveChanges')}
            </Button>
          </AppBarActions>
        </Col>
      </Row>
    </div>
  );
};

export default CreateVariant;
